module.exports = __webpack_public_path__ + "img/ring_r_e_0_null@2x.28f8cccb.png";